import { render, staticRenderFns } from "./editBank.vue?vue&type=template&id=0ded4fd9&scoped=true"
import script from "./editBank.vue?vue&type=script&lang=js"
export * from "./editBank.vue?vue&type=script&lang=js"
import style0 from "./editBank.vue?vue&type=style&index=0&id=0ded4fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded4fd9",
  null
  
)

export default component.exports